import {useQueryParam} from '../../../hooks/routes'

export function usePage() {
  const page = useQueryParam('page', '1')
  return Number(page)
}
